(() => {

    // Block Name
    const blockName = 'hero-section';

    // Variables
    let method = 'front';
    if ( document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin') ) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods
    var $ = jQuery.noConflict();

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined ) block = block[0].querySelector(`.block-${blockName}`);
        if ( block === false || block === null ) return;

        // Block Code Here


        function scrollbarWidth() {
            const containerWidth = $('.hero-slider .container').outerWidth();
            const windowWidth = $(window).width();
            $('.fz-scrolldown-button').css('width', (windowWidth - containerWidth) / 2);
        }

        scrollbarWidth();
        jQuery(window).on('resize', function () {
        	setTimeout(function () {
                scrollbarWidth();
        	}, 100);
        });
        $(document).on('click', '.fz-scrolldown-button', function(event){
            event.preventDefault();
            const viewportHeight = $(window).height();

            $('html, body').animate({
                scrollTop: viewportHeight,
                complete: function () {
                    //Hide your button here
                }
            }, 500);
        });

        // jQuery(window).on('resize', function () {
        // 	setTimeout(function () {
        //         const containerWidth = $('.hero-slider .container').outerWidth();
        //         const windowWidth = $(window).width();
        //         $('.fz-scrolldown-button').width((windowWidth - containerWidth) / 2);
        // 	}, 100);
        // });
        if($('.hero-slider').length > 0){
            let sliderSpeed = jQuery('.hero-slider').data('speed');
            sliderSpeed = parseInt(sliderSpeed,10) * 1000;

            const slider = new Swiper ('.hero-slider', {
                direction: 'horizontal',
                slidesPerView: 1,
                loop: true,
                noSwiping: true,
                noSwipingClass: 'swiper-slide',
                autoplay: {
                    delay: sliderSpeed,
                },
                speed: 1000,
                pagination: {
                    el: '.fz-slider-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + ' fz-slider-pagination--element"></span>';
                    },
                },
                navigation:false,


            });
            slider.on('resize', function () {
                slider.update()
            });
        }




    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if ( blocks.length > 0 ) {
            blocks.forEach( (block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
